














































import {Component, Vue, Watch} from 'vue-property-decorator';
import imageViewer from 'element-ui/packages/image/src/image-viewer.vue';
import _ from 'lodash';


@Component({
  components: {imageViewer}
})
export default class viewFileBar extends Vue {
  fileViewOption = {
    show: false
  };

  url = 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg';

  srcList = [
    'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
    'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
  ];

  imgList:any[] = [];

  excelUrl = '';
  wordUrl = '';
  pdfUrl = '';

  nowIndex = 0;
  viewerImgList: any = [];
  officeWebServerUrl = 'https://view.officeapps.live.com/op/view.aspx?src=';
  httpsOfficeWebServerUrl = 'https://view.officeapps.live.com/op/view.aspx?src=';

  created() {
    this.fileViewOption.show = true;
  }

  mounted() {
    if (this.viewType == 0) {
      this.loadImg();
    } else {
      this.loadImgs();
    }
  }

  // 文件查看方式，是单个查看，或者多文件查看
  get viewType() {
    return this.$store.state.fileExtra.viewType;
  }

  get file() {
    return this.$store.state.fileExtra.file;
  }

  get fileList() {
    return this.$store.state.fileExtra.fileList;
  }

  get defaultIndex() {
    return this.$store.state.fileExtra.defaultIndex;
  }

  normalizeFileUrl(url: string): string {
    if (!url) {
      return url;
    }
    const configuredDomain = process.env.VUE_APP_QINIU_FILE_URL || 'file.reersoft.cn';
    const domain = (/^https?:\/\//i.test(configuredDomain)
      ? configuredDomain
      : `https://${configuredDomain}`).replace(/\/+$/, '');
    return url.replace(/^https?:\/\/file\.reersoft\.com(?=\/|$)/i, domain);
  }

  downloadFile() {
    const params = ['doc', 'docx', 'png', 'jpg', 'jpeg', 'xls', 'xlsm', 'xlsx'];
    let fileName="";
    let url="";
    if(this.viewType==0){
      fileName = this.file.name || '未命名';
      url=this.file.url;
    }else{
      fileName=this.fileList[this.nowIndex].name||'未命名';
      url=this.fileList[this.nowIndex].url;
      console.log("file name:"+fileName);
    }

    url = this.normalizeFileUrl(url);
    if (!url) {
      return;
    }

    if (fileName == '未命名') {
      _.each(params, p => {
        if (url.indexOf(p) > -1) {
          if (fileName == '未命名') {
            fileName = fileName + '.' + p;
          }
        }
      })

    }
    const separator = url.indexOf('?') > -1 ? '&' : '?';
    let targetUrl =url + separator + 'attname=' + encodeURIComponent(fileName);
    window.location.href = targetUrl;
  }

  handleClose() {
    this.$store.commit('fileExtra/close', false);
  }

  viewTheFile(baseUrl) {
    baseUrl = this.normalizeFileUrl(baseUrl);
    const officeSource = encodeURIComponent(baseUrl);

    if ((baseUrl.indexOf('docx') > -1 || baseUrl.indexOf('doc') > -1)) {
      this.wordUrl = this.httpsOfficeWebServerUrl + officeSource;
    } else if (baseUrl.indexOf('pdf') > -1 || baseUrl.indexOf('PDF') > -1) {
      this.pdfUrl = baseUrl;
    } else if (baseUrl.indexOf('xlsm') > -1 || baseUrl.indexOf('xls') > -1 || baseUrl.indexOf('xlsx') > -1) {
      this.excelUrl = this.httpsOfficeWebServerUrl + officeSource;
    } else {
      this.imgList = [baseUrl];
    }
  }

  loadImg() {
    this.viewTheFile(this.file.url);
  }

  loadImgs() {

    this.nowIndex = this.defaultIndex;
    this.viewTheFile(this.fileList[this.nowIndex].url);

    // this.viewerImgList.push(..._.map(this.fileList, 'url'));
  }

  clearView(){
    this.imgList=[];
    this.excelUrl = '';
    this.wordUrl = '';
    this.pdfUrl = '';
  }
  nextFile() {

    this.clearView();
    // length 3  0,1,2
    if (this.fileList && this.fileList.length > 0) {
      if (this.nowIndex < this.fileList.length - 1) {
        this.nowIndex++;
        this.viewTheFile(this.fileList[this.nowIndex].url);
      }
    }

  }

  lastFile() {
    this.clearView();
    if (this.fileList && this.fileList.length > 0) {
      if (this.nowIndex > 0) {
        this.nowIndex--;
        this.viewTheFile(this.fileList[this.nowIndex].url);
      }
    }
  }

  // 这个关闭用不上了
  closeViewer() {
    this.imgList = [];
    this.handleClose();
  }

  // this.$viewer.view(
  //
  // @Watch('step') onChangeValue(newVal: any, oldVal: any) {
  //   this.fileViewOption.show = true;
  // }
}
